<template>
  <div>
    <template v-if="group.name">
      <q-item
        clickable
        dense
        class="q-pt-sm"
        :active="selected"
        active-class="bg-primary text-white"
        @click="$emit('toggle-category', group.id)"
      >
        <q-item-section
          avatar
          style="min-width: 24px;"
          @click.native.stop="open = !open"
        >
          <q-icon
            :name="open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"
            size="xs"
            :color="selected ? 'white' : 'grey'"
          />
        </q-item-section>
        <q-item-section class="text-weight-bold text-caption">
          {{ group.name }}
        </q-item-section>
        <q-item-section side>
          <q-badge
            :color="selected ? 'white' : 'grey-4'"
            :text-color="selected ? 'primary' : 'grey-8'"
          >
            {{ group.count }}
          </q-badge>
        </q-item-section>
      </q-item>
    </template>

    <q-list
      v-show="!group.name || open"
      dense
    >
      <q-item
        v-for="label in group.labels"
        :key="label.id"
        clickable
        :active="isSelected(label)"
        active-class="bg-primary text-white"
        @click="$emit('toggle', label)"
      >
        <q-item-section>{{ label.name }}</q-item-section>
        <q-item-section side>
          <q-badge
            :color="isSelected(label) ? 'white' : 'grey'"
            :text-color="isSelected(label) ? 'primary' : 'white'"
          >
            {{ label.count }}
          </q-badge>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { LabelSelection, LabelSummary } from '@/analysis/types';
import { isCategorySelected, isLabelSelected } from './selection';

interface CategoryGroup {
  id: number;
  name: string;
  count: number;
  labels: LabelSummary[];
}

export default defineComponent({
  emits: ['toggle', 'toggle-category'],
  props: {
    group: {
      type: Object as () => CategoryGroup,
      required: true,
    },
    selection: {
      type: Object as () => LabelSelection,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    selected(): boolean {
      return isCategorySelected(this.selection, this.group.id);
    },
  },
  methods: {
    isSelected(label: LabelSummary): boolean {
      return isLabelSelected(this.selection, label);
    },
  },
});
</script>
